export enum StudentRepositoryStateType {
	PENDING = 0,
	ONLINE = 1,
	OFFLINE = 2
}
